import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { GenericPaginated } from '../../models/generic-paginated';
import { LynxAlert } from '../../models/lynx-alert';

@Injectable({ providedIn: 'root' })
export class LynxAlertsService {
  private baseUrl = environment.url;
  private http = inject(HttpClient);
  private addParamsService = inject(AddParamsService);

  getAlerts(params?: Params): Observable<GenericPaginated<LynxAlert>> {
    return this.http.get<GenericPaginated<LynxAlert>>(`${this.baseUrl}/lynx-alerts`, {
      params: this.addParamsService.addParams(params),
    });
  }

  getAlertNames(): Observable<{ data: string[] }> {
    return this.http.get<{ data: string[] }>(`${this.baseUrl}/lynx-alerts/alert-names`);
  }
}
